<mat-icon class="table-icon {{customCssClasses ? customCssClasses.join(' ') : ''}}"
          matTooltip="{{tooltip}}"
          (click)="onDuplicateItemClicked($event)">
  {{defaultIcon}}
</mat-icon>

